import { render, staticRenderFns } from "./RecruiterCompanyIndustry.vue?vue&type=template&id=1132ef57&scoped=true&"
import script from "./RecruiterCompanyIndustry.vue?vue&type=script&lang=ts&"
export * from "./RecruiterCompanyIndustry.vue?vue&type=script&lang=ts&"
import style0 from "./RecruiterCompanyIndustry.vue?vue&type=style&index=0&id=1132ef57&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1132ef57",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VAutocomplete,VBtn,VForm})
